export default __webpack_public_path__ + "static/media/central_andes_2_2.4c554eb9.JPG";